export function u8(value: number) {
    return value & 0xff
}

export function u16(value: number) {
    return value & 0xffff
}
